export * from './fake-backend';
export * from './helper';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_helpers/index.ts